import React ,{ useEffect, useState }from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import AuthenticateService from '../auth/AuthenticateService';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import AuthLayout from './AuthLayout';
function OtpVerification (){
    // render() {

    const [formData, setFormData] = useState({ username: '', password: '' })
    const [error, setError] = useState('');
    const [isResending, setIsResending] = useState(false);

    const verifyToken = JSON.parse(sessionStorage.getItem('verify'));
    const navigate = useNavigate();
    // console.log(verifyToken.data.user_reference);
    const { http, setToken } = AuthenticateService();
    const [isLoging, setIsLoging]= useState(false)


    // console.log(verifyToken);
    if(verifyToken==null){
        // navigate('/');
        window.location.assign('/')
        sessionStorage.clear();

    }


    const resendOTP=()=>{
        setIsResending(true)

        http.post('/users/send-otp',{
            user_reference:verifyToken.data.user_reference,
            phone_number:verifyToken.data.phone_number
        })

            .then((res) => {
                // console.log(res);

                if (res.status === 200) {
                    setError('');
                    toast.success(res.data.message);
                    // sessionStorage.clear();
                    setIsResending(false)


                } else {
                    setError(res.message);
                    setIsResending(false)

                }
            })
            .catch((error) => {

                // setError('Failed to resend ')users/resend-otp
                // console.log(error.response.data.message);
                toast.error('Resend Failed : '+ error.response.data.message);
                setIsResending(false)


            });
    }

        const onSubmit = (e) => {
        
            setError('')
            setIsLoging(true)
            e.preventDefault()
    
            if (formData.otp === '' ) {
                setError('OTP is required');
                return; // Return early if validation fails
            }
            setError('');
            toast.info('Please Wait, Verification in progress', {
                // autoClose: false, // Set autoClose to false to keep the toast visible until manually closed
              });
    
            http.post('/users/verify-otp',{
                user_reference:verifyToken.data.user_reference,
                otp_code:formData.otp
            })
    
                .then((res) => {
                    // console.log(res.status);
    
                    if (res.status === 200 && res.data.status!==false) {
                        setError('');
                        navigate('/');
                        sessionStorage.clear();
                        setIsLoging(false)
    
                    }else {
                        setError(res.data.message);
                        setIsLoging(false)
                    }
                })
                .catch((error) => {
    
                    // setError('Failed to Sign In, Kindly check your username and password')
                    // console.log(error);
                    toast.error('Verification Failed : '+ error.response.data.message);
                    setIsLoging(false)
                });
    
        }
        return (
            <AuthLayout
                brandHeading="You're almost there"
                brandSubheading="Enter the verification code we sent to your phone to secure your account."
            >
                <ToastContainer />
                <div className="auth-heading">
                    <h3 className="text-1000">Account Verification</h3>
                    <p className="text-700">Enter the code sent to your phone to continue</p>
                </div>

                {error && (
                    <div className="alert alert-outline-danger d-flex align-items-center py-2 mb-3" role="alert">
                        <span className="fas fa-circle-exclamation text-danger fs--1 me-2"></span>
                        <p className="mb-0 flex-1 fs--1">{error}</p>
                    </div>
                )}

                <div className="alert alert-outline-warning d-flex align-items-center mb-4" role="alert">
                    <span className="fas fa-circle-info text-warning fs-3"></span>
                    <p className="mb-0 flex-1 fs--1">You haven't got OTP, please { isResending ? (

                            <>
                            <Spinner animation="grow" size="sm" /> Sending...
                            </>
                            ):(
                            <Link to='#' onClick={resendOTP}>resend</Link>
                            )}

                    </p>
                    <button className="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>

                <form onSubmit={(e) => {
                    e.preventDefault();
                    onSubmit(e);
                    }}>

                <div className="auth-field">
                    <label className="form-label" htmlFor="otp">Verification Code</label>
                    <div className="form-icon-container">
                        <input
                            id="otp"
                            className="form-control form-icon-input auth-otp-input"
                            type="text"
                            inputMode="numeric"
                            onChange={(e) => setFormData({ ...formData, otp: e.target.value })}
                            required={true}
                            placeholder="_ _ _ _ _ _"
                        />
                        <span className="fas fa-key text-900 fs--1 form-icon"></span>
                    </div>
                </div>

                <div className="mb-3">
                    <a href={ 'tel:*7006*60*00#' } className="fs--1 text-700">
                        <i className="nav-icon fa fa-phone me-1"></i> Dial USSD code to verify account: *7006*60*00#
                    </a>
                </div>

                <button className="btn-auth-primary" disabled={isLoging}>
                    { isLoging ? (
                        <>
                        <Spinner animation="border" size="sm" /> Verifying...
                        </>
                        ):(
                        <>Verify <FontAwesomeIcon icon={faArrowRight} className="fs--1" /></>
                    ) }
                </button>
                </form>

                <div className="text-center mt-4">
                    <Link to='/register' className="fs--1 fw-bold">Create an account</Link>
                </div>
            </AuthLayout>
        )
    // }
}

export default OtpVerification;